<div class="maindiv">
    <img class="confirmedlogo" src="/assets/confirmedemail.jpg" alt="">

    <h1>Welcome to Lebtivity</h1>
    <h2>Your account has been successfully registered</h2>
    <h3>Redirecting... Please wait</h3>
    <mat-spinner></mat-spinner>
    <div class="redirectionerror">If you're not automatically redirected please <strong class="clickhere"><a href='#'>click here</a></strong></div>
</div>
